import { addToCart } from '~/js/lib/cart'; // eslint-disable-line

export default (node) => {
  /**
   * Data + elements
   */
  const showMoreButton = node.querySelector('[data-order-details-show]');
  const allItems = node.querySelectorAll('[data-order-items]');
  const reorderButton = node.querySelector('[data-button-reorder]');

  /**
   * Functions
   */
  const showMoreItems = () => {
    allItems.forEach((item) => {
      item.classList.remove('hidden');
    });
    showMoreButton.classList.add('hidden');
  };

  const reorderItems = async () => {
    const variantsIds = reorderButton.dataset.buttonReorder.split(',');
    const reorderMessage = reorderButton.dataset.reorderMessage;

    if (confirm(reorderMessage)) {
      if (variantsIds.length) {
        const itemToAdd = variantsIds.map((id) => {
          return {
            id: Number(id),
            quantity: 1,
          };
        });

        await addToCart(itemToAdd);

        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    }
  };

  /**
   * Init
   */
  const init = () => {
    if (showMoreButton) showMoreButton.addEventListener('click', showMoreItems);
    if (reorderButton) reorderButton.addEventListener('click', reorderItems);
  };

  init();
};
